import React, { Component } from "react";
import Collapsible from "react-collapsible";
import HttpServices from "../../../utils/Http.services";
import { checkTranslation, conditionalWidth, imageAddress, translate } from "../../../utils/useful";
import { diagramComponents, diagramGroups } from "../../../variables/diagramFunctions";
import FormViewer from "../../FormViewer";
import LoaderButton from "../../LoaderButton";
import SidebarView from "../../SidebarView";
import StagesManager from "../../StagesManager";
import TableViewer from "../../TableViewer";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import FixedView from "../../FixedView";
import ReactLoaderSpinner from "react-loader-spinner";
import DiagramAddThirdParty from "./DiagramAddThirdParty";
import { element } from "mammoth/mammoth.browser";

class DiagramAddElements extends Component {

    state = {
        trigger: true,
        action: true,
        fixed: true,
        closedGroups: {},
        // parts: [
        //     { label: '{{lang}}Variables', key: 'variables', icon: '/assets/icons/useful/text.svg' },
        // ],
        defaultIsDone: false,
        // selectedParent: { type: "flowControl", _id: this.props.variables.appletId, default: true },
        applets: [],
        headers: [
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}variable.name', required: false } },
            { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}type', placeholder: '{{lang}}type', type: 'local', items: [{ title: 'hub', value: 'hub' }, { title: 'applet', value: 'applet' }, { title: 'frame', value: 'frame' }, { title: 'record', value: 'record' }, { title: 'temp', value: 'temp' },], required: true } },
        ],
        systemSections: [
            { type: 'workflowUnits', mode: 'system', name: 'Workflow units', icon: '/assets/icons/useful/directions.png' },
            { type: 'controlUnits', mode: 'system', name: 'Control units', icon: '/assets/icons/useful/dashboard (1).png' },
            { type: 'thirdParties', mode: 'system', name: 'Third Parties', icon: '/assets/icons/useful/api.png' },
        ],
        frames: [],
    }

    componentDidMount() {
        this.getMyApplets()

    }

    selectDefaultSection = () => {
        let defaultSection = this.state.selectedParent?.type
        if (!this.state.defaultIsDone && !defaultSection) {
            let type = 'workflow'
            defaultSection = "controlUnits"
            if (type == 'workflow') {
                defaultSection = "workflowUnits"
            }

            this.setState({ defaultIsDone: true })
        }

        this.state.systemSections.forEach(section => {
            if (section.type == defaultSection) {
                this.chooseParent(section)
            }
        });

    }


    chooseParent = (data) => {

        let item = data
        if (data.mode == 'system') {
            item = data
            if (this.stageManager) {
                if (data.type == 'thirdParties') {
                    this.stageManager.changeStage('thirdParties')
                } else if (data.type == 'applets') {
                    this.stageManager.changeStage('applets')
                } else {
                    this.stageManager.changeStage('units')
                }
            }

            this.setState({ selectedParent: data })


        } else {
            this.stageManager.changeStage('units')
            let myData = { ...data }
            // data.type = data?.features ? data.features[0] : ''
            this.setState({ selectedParent: myData.applet })

        }



        // if (this.state.selectedParent?._id != item?.applet?._id || (!this.state.selectedParent?._id && this.state.selectedParent?.type != item.type)) {
        //     let selectedParent = data
        //     this.setState({ selectedParent })
        // }
        // else {
        //     this.setState({ selectedParent: null })
        // }
    }


    openFirstView = () => {
        let view = this.state.fixed
        this.setState({ fixed: !view }, () => {
            if (this.state.fixed == true) {
                this.firstView.hideView()
            } else {
                this.firstView.showView()
                setTimeout(() => {
                    this.setState({ showFixed: true })
                    this.selectDefaultSection()
                }, 100);
            }
        })
    }


    getMyApplets = () => {
        let data = {}
        data.username = this.props.variables.user?.username
        this.setState({ isLoadingData: true })
        HttpServices.request('getHubByUsername', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            fetchResult.applets.forEach(element => {
                element.isParent = true
            });
            fetchResult.applets?.forEach(element => {
                if (element.applet?._id == this.props.variables?.appletId) {
                    this.selectApplet(element.applet)
                }
            });

            this.setState({ applets: fetchResult.applets }, () => {
                // this.setFrame(this.state.applets[0])
            })
            this.setState({ isLoadingData: false }, () => {
            })
        })
    }
    getFrames = (applet, cb) => {
        HttpServices.request('getFrames', { applet }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ frames: (fetchResult.info ?? []) }, () => {
                if (cb) {
                    cb()
                }
            })
        })
    }
    setFrame = (item) => {
        this.chooseParent(item)
        // this.setState({ currentSelect: item.applet }, () => {
        // })
    }

    selectApplet = (item) => {
        this.getFrames(item, () => {


            this.setState({ currentApplet: item }, () => {
            })
            if (this.stageManager) {
                this.stageManager.changeStage('appletSelected')
            }
        })
    }

    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups
        closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
        this.setState({ closedGroups })
    }

    showChildsList = (parent) => {
        if (parent) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: parent })
        } else {
            this.subSidebarView.closeSidebar()
            setTimeout(() => {
                this.setState({ selectedParent: parent })
            }, 500);
        }
    }

    showApplet = (applet) => {
        if (applet) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: applet })
        }
    }

    // openVariables = () => {
    //     this.varSidebarView.open()
    //     this.openFirstView()
    // }

    // addNewVariables = () => {
    //     this.stageManager.changeStage('addNew')
    // }

    backStage = (stage) => {
        this.stageManager.changeStage(stage)
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'DiagramEditor') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }


    onTouchMove = (e, prop) => {
        let x
        let y
        if (e.touches) {
            x = e.touches[0].clientX
            y = e.touches[0].clientY
        }
        let id = prop.key
        if (this.state.dragId !== id && this.dragOverId != id) {
            this.setState({ dragId: id })
        }
        let ghost = document.getElementById('drag-ghost')
        if (ghost) {
            ghost.style.top = (y - Number(ghost.style.height.replace('px', '')) / 2) + 'px'
            ghost.style.left = (x - Number(ghost.style.width.replace('px', '')) / 2) + 'px'
        }
    }

    onTouchEnd = (e) => {
        this.setState({ dragId: null })
        this.props.onDrop(e)
    }

    onClick = (cprop) => {
        if (cprop.isParent) {
            this.showChildsList(cprop)
        } else {
            if (!this.props.draggable) {
                this.props.onClick(cprop, this.state.selectedParent?.type)
            }
        }
    }



    onDragStart = (e, formItem) => {

        this.props.onDragStart(e, formItem, 'function', this.state.selectedParent)

        setTimeout(() => {
            this.firstView.hideView()
        }, 100);
    }

    openAppletSelect = () => {
        this.chooseParent({ type: 'applets', mode: 'system', name: 'applets', },)
    }

    render() {
        // if (this.props.showElements) {
        return (
            <div className='w-100 h-100' ref={el => this.firstCurrentNode = el}>
                <button style={{ paddingTop: 7, paddingBottom: 7 }} className={" pld-3 prd-5  flexc br-20 " + (this.state.fixed == true ? " add-element " : " add-element-selected ")} onClick={() => this.openFirstView()}>
                    <img width={20} src='/assets/icons/pagebuilder/plus-black.svg' />
                    <p className='font-size-14 black weight-500'>{translate('Element')}</p>
                </button>
                <div className='w-100 h-100'>
                    <FixedView onHide={() => this.setState({ fixed: true })} ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} fixed={this.state.fixed} topOffset={5} bottomOffset={36} xOffset={285} zIndex={20} >
                        <div className='br-10 bg-white shadow-3' style={{ width: "400px", height: "300px" }}>

                            {this.state.isLoadingData && (
                                <div className='flexcc w-100 pt-5'>
                                    <ReactLoaderSpinner type={"Oval"} color={this.props.colors?.primaryColor ?? '#eee'} height={40} width={40} />
                                </div>
                            )}

                            {!this.state.isLoadingData && (
                                <div className='flexcb w-100 h-100' style={{}}>
                                    <div className='h-100' style={{ borderRight: '1px solid #eee', width: "175px", }} >
                                        <div className='h-100' style={{}} >

                                            {/* {this.state.isLoadingData && (
                                                    <div className='flexcc w-100 pt-5'>
                                                        <ReactLoaderSpinner type={"Oval"} color={this.props.colors?.primaryColor ?? '#eee'} height={40} width={40} />
                                                    </div>
                                                )} */}

                                            <div className="overflow-auto sc-gray2 w-100 px-1 pb-3" style={{ height: '100%' }}>

                                                <div className=' flexcc pt-1 mb-1' style={{}}>
                                                    <div className='w-100 flexc ' style={{ borderBottom: "0px solid #eee", height: '30px', cursor: 'auto' }}>
                                                        {/* <p className='px-2 font-size-13 main-c2'>Drag an element</p> */}
                                                        <input placeholder={translate('Search')} className='py-1 px-2 br-5 w-100 text-semibold' style={{ backgroundColor: '#F2F2F2', border: '1px solid #F2F2F7' }} />
                                                    </div>
                                                </div>

                                                {this.state.systemSections.map((section, index) => {
                                                    return (
                                                        <button key={index} className="  w-100 br-4 my-1 flexcb cursor-pointer transition-all" onClick={() => this.chooseParent(section)} style={{ borderLeft: this.state.selectedParent?.type == section.type ? '4px solid #007aff' : '0px solid #fff', backgroundColor: this.state.selectedParent?.type == section.type ? '#007aff20' : '' }}>
                                                            <div className="px-2 flexc py-2 w-100 text-smaller " draggable={false} >
                                                                <div className="flexc" width={22}>
                                                                    <img src={section.icon} width={14} />
                                                                </div>
                                                                <p className="mld-3 text-start text-semibold" style={{ whiteSpace: 'nowrap' }}>{checkTranslation(section.name)}</p>
                                                            </div>
                                                            <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' />
                                                        </button>
                                                    )
                                                })}
                                                {/* <button className="  w-100 br-4 my-1 flexcb cursor-pointer" onClick={() => this.chooseParent('workflow')} style={{ backgroundColor: this.state.selectedParent?.type == 'workflow' ? '#eee' : '' }}>
                                                    <div className="px-2 flexc py-2 w-100 text-smaller " draggable={false} >
                                                        <div className="flexc" width={22}>
                                                            <img src={'/assets/icons/useful/directions.png'} width={14} />
                                                        </div>
                                                        <p className="mld-3 text-start text-semibold" style={{ whiteSpace: 'nowrap' }}>{checkTranslation("Workflow units")}</p>
                                                    </div>
                                                    <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' />
                                                </button> */}




                                                {/* <div className=" w-100 br-8 my-1 flexcb cursor-pointer" style={{}}>
                                                    <button className="px-2 py-2  flexc w-100 text-smaller " draggable={false} style={{}} onClick={() => { this.chooseParent('thirdparties') }}>
                                                        <div className="flexc" width={22}>
                                                            <img src={'/assets/icons/useful/api.png'} width={14} />
                                                        </div>
                                                        <p className="mld-3 text-start text-semibold" style={{ whiteSpace: 'nowrap' }}>{translate("Third Parties")}</p>
                                                    </button>
                                                    <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' />
                                                </div> */}

                                                <div className="w-100 mt-1" style={{ marginBottom: 3, height: 1, background: '#eee' }}>
                                                </div>


                                                {/* <div className='flexcc ' style={{ borderBottom: "0px solid #eee", zIndex: 10,  }}>
                                                            <div className='w-100 flexcc ' style={{ borderBottom: "0px solid #eee", height: '30px', backgroundColor: "#fff", }}>
                                                                <input placeholder={translate('Search')} className='px-2 py-1 br-5 w-100 text-semibold' style={{ backgroundColor: '#fff', border: '0px solid #F2F2F7' }} />
                                                            </div>
                                                        </div> */}
                                                <div className="">
                                                    <div ref={el => this.appletBut = el} className="px-1 py-1 pb-1 w-100 br-4 mt-0 flexcb transition-all" style={{ backgroundColor: this.state.selectedParent?.type == "applets" ? "#007aff20" : '#f2f2f2', borderLeft: this.state.selectedParent?.type == "applets" ? "4px solid #007aff" : '0px solid #fff', borderBottom: '2px solid rgb(204,204,204)' }}>
                                                        <div className=" flexc text-smaller" style={{ cursor: 'pointer', width: 'calc(100% - 25px)' }} onClick={() => { this.openAppletSelect() }}>
                                                            {this.state.currentApplet ? (
                                                                <>
                                                                    <div className="flexcc">
                                                                        <img draggable={false} src={this.state.currentApplet?.image ? imageAddress(this.state.currentApplet?.image) : ('/assets/icons/applets/' + ((this.state.currentApplet?.features && this.state.currentApplet?.features[0]) ? String(this.state.currentApplet?.features[0]).toLowerCase() : String(this.state.currentApplet?.type).toLowerCase()) + ".png")} className='br-20 ' width={22} />
                                                                    </div>
                                                                    {/* <img draggable={false} src={'/assets/icons/applets/database.png'} className='br-20' width={22} /> */}
                                                                    <div className="mld-2 text-start " draggable={false} style={{ width: 'calc(100% - 25px)' }}>
                                                                        <p className=" font-size-10 "  >{'Selected applet'}</p>
                                                                        <p draggable={false} className="text-bold w-100" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.state.currentApplet?.name)}</p>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="w-100 text-start">
                                                                    <p className=" font-size-10 "  >{'No applet is selected'}</p>
                                                                    <p className=" font-size-10 text-bold"  >{'Click and select a applet'}</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="px-1 flexcc">
                                                            <img src='/assets/icons/useful/setting-1.png' width={14} className='flexcc  rotate-90 ' />
                                                        </div>
                                                    </div>
                                                    <div className="w-100 opacity-2 px-1">
                                                        {/* <div className="br-4 w-100" style={{ height: 2, background: '#000' }}>
                                                        </div> */}
                                                        <div className="flexc w-100  px-1">
                                                            <img src='/assets/icons/useful/sort-down.png' width={12} className='flexcc  ' style={{ transform: 'translate(0px,-2px)' }} />
                                                        </div>
                                                    </div>
                                                </div>



                                                {/* <p className="text-semibold px-2 mt-2 text-small">{translate("Frames units")}</p> */}
                                                {this.state.currentApplet && (
                                                    <div style={{ marginTop: -3 }}>
                                                        {this.state.frames.map((item, index) => {
                                                            if (item && this.state.selectedParent) {
                                                                return (
                                                                    <button className="px-1 py-2 w-100 br-4  flexcb transition-all" key={item._id} onClick={() => { this.setFrame(item) }} style={{ borderLeft: this.state.selectedParent._id == item.applet._id ? '4px solid #007aff' : '0px solid #fff', backgroundColor: this.state.selectedParent._id == item.applet._id ? '#007aff20' : '' }}>
                                                                        <div className=" flexc w-100 text-smaller">
                                                                            <img draggable={false} src={item.applet?.image ? imageAddress(item.applet?.image) : ('/assets/icons/applets/' + ((item.applet?.features && item.applet?.features[0]) ? String(item.applet?.features[0]).toLowerCase() : String(item.applet?.type).toLowerCase()) + ".png")} className='br-20 ' width={22} />
                                                                            <div className="mld-2 text-start" draggable={false} style={{ whiteSpace: 'nowrap' }}>
                                                                                <p draggable={false} className="text-semibold font-size-12">{checkTranslation(item.applet.name)}</p>
                                                                                {/* <p className="color-gray-3 font-size-10"  >{item.features[0]}</p> */}
                                                                            </div>
                                                                        </div>
                                                                        <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' />
                                                                    </button>
                                                                )
                                                            }
                                                        })}
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>


                                    <div className='h-100' style={{ width: "225px", }} >
                                        <div className='h-100 overflow-auto sc-gray2' style={{}} >

                                            <StagesManager ref={el => this.stageManager = el} fast={true}>

                                                <div stageName="applets" stage={1}>
                                                    <div className="px-2 pt-2 pb-1" style={{ borderBottom: '1px solid #eee' }}>
                                                        <p className="text-small text-bold mb-1">{translate("Select an applet")}</p>
                                                        {/* <p className="text-smaller text-semibold mb-1">{translate("Frames of this applet can be used in the automation")}</p> */}

                                                    </div>
                                                    {this.state.applets?.map((item, index) => {
                                                        if (item && this.state.selectedParent) {
                                                            return (
                                                                <button className="px-1 py-2 w-100 br-4 my-1 flexcb transition-all" key={item?._id} onClick={() => { this.selectApplet(item.applet) }} style={{ borderLeft: this.state.selectedParent._id == item.applet?._id ? '4px solid #007aff' : '', backgroundColor: this.state.selectedParent._id == item.applet?._id ? '#007aff20' : '' }}>
                                                                    <div className=" flexc w-100 text-smaller">
                                                                        <img draggable={false} src={item.applet?.image ? imageAddress(item.applet?.image) : ('/assets/icons/applets/' + ((item.applet?.features && item.applet?.features[0]) ? String(item.applet?.features[0]).toLowerCase() : String(item.applet?.type).toLowerCase()) + ".png")} className='br-20' width={22} />
                                                                        <div className="mld-2 text-start" draggable={false} style={{ whiteSpace: 'nowrap' }}>
                                                                            <p draggable={false} className="text-semibold font-size-12">{checkTranslation(item.applet?.name)}</p>
                                                                            {/* <p className="color-gray-3 font-size-10"  >{item.features[0]}</p> */}
                                                                        </div>
                                                                    </div>
                                                                    <img src='/assets/icons/angle-right.svg' width={18} className='flexcc opacity-2' />
                                                                </button>
                                                            )
                                                        }
                                                    })}
                                                </div>


                                                <DiagramAddThirdParty stage={1} stageName="thirdParties" width={this.props.width} variables={this.props.variables} onTouchEnd={this.onTouchEnd} onTouchMove={this.onTouchMove} onDragStart={this.onDragStart} />


                                                <div stage={1} stageName="appletSelected" className="text-center flexcc pt-5 flex-column px-3">
                                                    <img src="/assets/icons/useful/check.png" height={30} alt="" />
                                                    <p className="text-small text-semibold mt-2">{translate("Applet selected")}</p>
                                                    <p className="text-smaller">{translate("You can use applet's frames in this automation.")}</p>
                                                </div>

                                                <div stage={0} stageName="units">
                                                    <div className="top-0" style={{ borderBottom: "1px solid #eee", background: '#fff', borderRadius: '0px 8px 0px 0px', zIndex: 1, position: 'sticky', }}>
                                                        <div className="px-2 pt-2 pb-1 flexc " style={{ borderBottom: '0px solid #eee', }}>
                                                            {/* <img draggable={false} src={this.state.selectedParent?.icon} className='' width={22} /> */}
                                                            <p className="text-small text-bold ">{checkTranslation(this.state.selectedParent?.name)}</p>
                                                        </div>
                                                        <div className="flexc px-2 pt-0 mb-0 pb-1" >
                                                            <button className="" onClick={() => this.setState({ currentTab: null })}>
                                                                <p className="pb-1 px-1 font-size-12 text-semibold" style={{ color: this.state.currentTab == null ? '#007aff' : '', borderBottom: this.state.currentTab == null ? '2px solid #007aff' : '2px solid #fff' }}>All</p>
                                                            </button>
                                                            <button className="" onClick={() => this.setState({ currentTab: 'operator' })}>
                                                                <p className="pb-1 px-1 font-size-12 text-semibold" style={{ color: this.state.currentTab == 'operator' ? '#007aff' : '', borderBottom: this.state.currentTab == 'operator' ? '2px solid #007aff' : '2px solid #fff' }}>Operators</p>
                                                            </button>
                                                            <button className="" onClick={() => this.setState({ currentTab: 'trigger' })}>
                                                                <p className="pb-1 px-1 font-size-12 text-semibold" style={{ color: this.state.currentTab == 'trigger' ? '#007aff' : '', borderBottom: this.state.currentTab == 'trigger' ? '2px solid #007aff' : '2px solid #fff' }}>Triggers</p>
                                                            </button>
                                                            <button className="" onClick={() => this.setState({ currentTab: 'action' })}>
                                                                <p className="pb-1 px-1 font-size-12 text-semibold" style={{ color: this.state.currentTab == 'action' ? '#007aff' : '', borderBottom: this.state.currentTab == 'action' ? '2px solid #007aff' : '2px solid #fff' }}>Actions</p>
                                                            </button>
                                                        </div>
                                                    </div>





                                                    <div className=" sc-gray2 w-100 px-1" style={{ height: '254px' }}>
                                                        <div style={{ borderBottom: '0px solid #eeeeeecc' }}>
                                                            <div >
                                                                {Object.values(diagramComponents).map((formItem, index) => {
                                                                if (((formItem.parents?.includes(this.state.selectedParent?.type) || (this.state.selectedParent?.features && formItem.parents?.includes(this.state.selectedParent?.features[0])) || (formItem.parents?.includes('*'))) && (!this.state.currentTab || this.state.currentTab == formItem.group))) {
                                                                        let color = 'rgb(75,126,255)'
                                                                    if (formItem.group == 'operator') {
                                                                            color = '#00c746'
                                                                        }
                                                                        if (formItem.group == 'trigger') {
                                                                            color = '#ffb700'
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={formItem.type}>
                                                                                <div className="py-2 w-100 flexcb br-10" style={{ cursor: 'move' }} key={formItem.type} onClick={() => { if (formItem.isParent) this.showChildsList(formItem) }} onTouchStart={(e) => this.onDragStart(e, formItem)} onDragStart={(e) => this.onDragStart(e, formItem)} onTouchMove={(e) => this.onTouchMove(e, formItem)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!formItem.isParent}>
                                                                                    <div className="flexc">
                                                                                        <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 prd-1' draggable={false} />
                                                                                        <div key={index} className=" flexc w-100 text-smaller " style={{}}>
                                                                                            <img draggable={false} src={formItem.icon} height={18} style={{ opacity: '1' }} />
                                                                                            <p draggable={false} className="mld-2 text-semibold">{checkTranslation(formItem.name ?? formItem.title)}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    {formItem.isParent && (
                                                                                        <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ position: 'absolute', top: 8, right: 8, userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                                                    )}
                                                                                    <div className="br-4 px-2 py-1 mrd-2 text-semibold text-capitalize" style={{ background: '#f6f6f6', color }}>
                                                                                        <p className="text-smallest">{formItem.group}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        );
                                                                    }
                                                                })}
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>

                                            </StagesManager>



                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </FixedView>



                </div >

                {
                    this.state.dragId && (
                        <div id="drag-ghost" className="drag-ghost" style={{ zIndex: 20000, position: 'absolute', top: 10, left: 0, height: 80, width: 80, backgroundColor: 'rgba(230,240,245,0.7)', border: '1px dotted #007aff40', borderRadius: 2 }}></div>
                    )
                }
            </div >
        )
        // } else {
        //     return (
        //         <div></div>
        //     )
        // }
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DiagramAddElements);